import styled from 'styled-components';
import { Link } from 'gatsby';

export default styled(Link)`
  text-decoration: none;
  padding: .5rem;
  display: block;
  white-space: nowrap;
  color: ${(props) => props.theme.fontColor};
  @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
    color: white;
  }

  &:hover {
    color: ${(props) => props.theme.primaryColor};
    @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
      color: ${(props) => props.theme.fontColor};
    }
  }
`;
